export const mockDataUSA = {
  header: {
    logoText: "EPG United States",
    buttons: [
      { text: "Book a Call", type: "outline" },
      { text: "Privacy", type: "outline" }
    ]
  },
  hero: {
    badge: "Investing in Precious Metals Since 2015",
    headline: "Invest in Gold and Silver on Your Own Terms!",
    subheading: "Welcome to Electrum Prosperity Group USA!",
    benefits: [
      "Authorized precious metals distributor, compliant with regulations",
      "Secure storage and dedicated logistics services",
      "Gold bonuses for confirmed referrals",
      "Simple platform to manage directly from your phone"
    ],
    stats: [
      { value: "+$80", label: "In gold for", sublabel: "each referral" },
      { value: "$500", label: "Cash", sublabel: "REWARDS" },
      { value: "$820", label: "Total", sublabel: "POTENTIAL" },
      { value: "Weekly", label: "Payments", sublabel: "" }
    ],
    ctas: [
      { text: "Book a Call", type: "primary" },
      { text: "Join Now!", type: "secondary" }
    ],
    email: "electrumpg@gmail.com",
    videoUrl: process.env.REACT_APP_VIDEO_URL || "https://www.7kmetals.com/stusimonsen/share/xyt25"
  },
  features: [
    {
      title: "Verified Distributor",
      description: "Official partner authorized to sell precious metals according to regulations"
    },
    {
      title: "Secure Storage",
      description: "Your gold and silver are stored in secure, insured facilities"
    },
    {
      title: "Attractive Bonuses",
      description: "Earn gold bonuses for every confirmed referral you bring"
    }
  ],
  testimonials: [
    {
      name: "John Smith",
      text: "EPG has changed my approach to savings. Now I invest in gold with confidence!",
      role: "EPG Member"
    },
    {
      name: "Sarah Johnson",
      text: "The referral system is fantastic. I've already earned significant gold bonuses!",
      role: "EPG Ambassador"
    }
  ],
  contactForm: {
    title: "READY TO GET STARTED?",
    subtitle: "Fill out the form below and we'll contact you shortly!",
    fields: {
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number"
    },
    privacyText: "I agree to the",
    privacyLink: "privacy policy",
    submitButton: "Submit"
  },
  footer: {
    ctaTitle: "READY TO START YOUR JOURNEY?",
    ctaButton: "Join EPG Now",
    links: ["Privacy Policy", "Contact Us"],
    copyright: "© 2024 Electrum Prosperity Group USA. All rights reserved.",
    email: "electrumpg@gmail.com",
    cta: "READY TO GET STARTED?"
  }
};
